export default function getVWKey() {
    if (Q3.editMode && !Q3.mobileView) { return "sizeLg"; }

    const { width, height } = Q3.RenderManager.getSize();

    if ( width / height < 1) { return "sizeSm"; }
    else { return "sizeLg"; }
}